import { Stack, styled } from '@mui/material'
import { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer'
import { COLLAPSE_ANIMATION } from '@/constants/navigationDrawer'

import { Scrollbar } from '../Scrollbar'
import { NAV_MENU_TEST_IDS } from './constants'
import { NavMenuContent } from './NavMenuContent'

type NavMenuContainerProps = MuiDrawerProps & {
  drawerWidth: number
}

const TOP_BAR_HEIGHT = 72
const SAFE_ZONE_MARGIN = 8

const NavMenuContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'drawerWidth'
})<NavMenuContainerProps>(({ drawerWidth }) => ({
  position: 'relative',
  width: drawerWidth,
  transition: COLLAPSE_ANIMATION,
  whiteSpace: 'nowrap',
  height: `calc(100vh - ${TOP_BAR_HEIGHT}px)`,
  overflow: 'hidden',
  zIndex: 1000
}))

type NavMenuProps = {
  drawerWidth: number
}

export const NavMenu = (props: NavMenuProps) => {
  const { drawerWidth } = props

  return (
    <NavMenuContainer
      variant="permanent"
      drawerWidth={drawerWidth}
      data-testid={NAV_MENU_TEST_IDS.NAV_MENU_CONTAINER}
    >
      <Stack
        direction="column"
        data-testid={NAV_MENU_TEST_IDS.NAV_MENU_STACK}
        sx={{
          transition: COLLAPSE_ANIMATION,
          width: drawerWidth,
          maxWidth: drawerWidth,
          overflowX: 'hidden',
          overflowY: 'auto',
          height: `calc(100% - ${TOP_BAR_HEIGHT - SAFE_ZONE_MARGIN}px)`,
          backgroundColor: 'background.paper',
          position: 'fixed',
          borderRight: (theme) => `1px solid ${theme.palette.divider}`
        }}
      >
        <Scrollbar>
          <NavMenuContent />
        </Scrollbar>
      </Stack>
    </NavMenuContainer>
  )
}
